module.exports = __webpack_public_path__ + "static/media/14.b7cee5cf.JPG";